<template>
  <div class="dashboard-container">
    <div class="app-container">
      <el-card shadow="never">
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="查询状态:">
              <el-select
                v-model="listQuery.status"
                clearable
                placeholder="请选择状态"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="未沟通" :value="1"></el-option>
                <el-option label="已沟通" :value="2"></el-option>
                <el-option label="一面" :value="3">一面</el-option>
                <el-option label="二面" :value="4">二面</el-option>
                <el-option label="三面" :value="5">三面</el-option>

              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch" size="small" class="btns" icon="el-icon-search">搜索</el-button>
            </el-form-item>
        </el-form>
        <el-table border :data="list" style="width: 100%">
          <el-table-column prop="recruitmentName" label="名称">
          </el-table-column>
          <el-table-column prop="position" label="职位"></el-table-column>
          <el-table-column prop="recruitmentPhone"  label="联系电话">
          </el-table-column>
          <el-table-column label="简历">
            <template slot-scope="scope">
              <a :href="scope.row.recruitmentUrl" target="_blank">查看简历</a>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.status" @input="open(scope.row)">
                <el-radio :label="1">未沟通</el-radio>
                <el-radio :label="2">已沟通</el-radio>
                <el-radio :label="3">一面</el-radio>
                <el-radio :label="4">二面</el-radio>
                <el-radio :label="5">三面</el-radio>
                <el-radio :label="6">未通过</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column prop="record" label="沟通记录">
          </el-table-column>
          <el-table-column label="操作" width="180px" header-align="center">
            <template slot-scope="scope">
              <el-button type="text"  @click="editInfo(scope.row.recruitmentId)">编辑</el-button>
              <!--                <el-button type="text" icon="el-icon-delete">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>

        <!-- 编辑弹窗 -->
        <el-dialog
          title="招聘信息"
          :visible.sync="dialogVisible"
          width="50%"
        >
          <el-form>
            <el-form-item label="名称">
              <el-input v-model="ufrom.recruitmentName" style="width:100%"></el-input>
            </el-form-item>
            <el-form-item label="联系电话">
              <el-input v-model="ufrom.recruitmentPhone"  maxlength="11" ></el-input>
            </el-form-item>
            <el-form-item label="职位">
              <el-input v-model="ufrom.position" ></el-input>
            </el-form-item>
            <el-form-item label="状态:">
              <el-select
               style="width: 100%;"
                v-model="ufrom.status"
                clearable
                placeholder="请选择状态"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="未沟通" :value="1"></el-option>
                <el-option label="已沟通" :value="2"></el-option>
                <el-option label="一面" :value="3">一面</el-option>
                <el-option label="二面" :value="4">二面</el-option>
                <el-option label="三面" :value="5">三面</el-option>
                <el-option label="未通过" :value="6">未通过</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="沟通记录:">
              <el-input
                v-model="ufrom.record"
                type="textarea"
                :rows="6"
                placeholder="请输入内容"
              >
              </el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="save"
            >保存</el-button
            >
          </span>
        </el-dialog>
        <el-pagination
          class="page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="listQuery.pageSize"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="listQuery.pageNo"
          layout="prev, pager, next,sizes, jumper"
          :total="total"
        >
        </el-pagination>
      </el-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import apiBaseUrl from '../../../config/api'

export default {
  data() {
    return {
      ufrom: {
        status: '',
        record: '',
        recruitmentId: '',
        recruitmentName: '',
        position: '',
        recruitmentPhone:'',
        adminNo: ''
      },
      listQuery: {
        pageSize: 10,
        pageNo: 1,
        adminNo: '',
        status: '',
      },
      list: [],
      total: 0,
      radio: '',
      dialogVisible: false
    };
  },
  created() {
    this.listData();
  },
  methods: {
    //分页
    handleSizeChange(pageSize) {
      this.listQuery.pagesize = pageSize;
      this.listData();
    },
    // 进入某一页
    handleCurrentChange(newPage) {
      this.listQuery.pageNo = newPage;
      this.listData();
    },
    save() {
      axios.put(`${apiBaseUrl}/recruitmentInformation/update`, this.ufrom,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.message,
              type: "success"
            })
            this.dialogVisible = false
            this.listData()
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            })
          }
        })
    },
    open(data) {
      this.$confirm(`确定修改招聘信息状态吗？`, `提示`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        this.ufrom.status = data.status
        this.ufrom.recruitmentId = data.recruitmentId
        axios.put(`${apiBaseUrl}/recruitmentInformation/update`, this.ufrom,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(res => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.message,
                type: "success"
              })
              this.dialogVisible = false
            } else {
              this.$message({
                message: res.data.message,
                type: "error"
              })
            }
          })
      }).catch(() => {
        data.status = 1
      })
    },
    editInfo(id) {
      axios.get(`${apiBaseUrl}/recruitmentInformation/getById/${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.code === 200) {
            this.ufrom.status = res.data.data.info.status
            this.ufrom.record = res.data.data.info.record
            this.ufrom.recruitmentId = res.data.data.info.recruitmentId
            this.ufrom.recruitmentName = res.data.data.info.recruitmentName
            this.ufrom.position = res.data.data.info.position
            this.ufrom.recruitmentPhone = res.data.data.info.recruitmentPhone
            this.ufrom.adminNo = res.data.data.info.adminNo
            this.dialogVisible = true
          }
        })
    },
    handleSearch() {
      this.listQuery.pageNo = 1
      this.listData()
    },
    handleClose() {
    },
    listData() {
      //点击客资管理显示您好，xx老师
      let admin = window.localStorage.getItem("admin");
      if (admin != null) {
        this.listQuery.adminNo = JSON.parse(admin).adminNo;
      } else {
        let teacher = window.localStorage.getItem("teacher");
        if (teacher != null) {
          this.listQuery.adminNo = JSON.parse(teacher).adminNo;
        }
      }
      axios.post(`${apiBaseUrl}/recruitmentInformation/page`, this.listQuery,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.list = res.data.data.list.records
          this.listQuery.pageSize = res.data.data.list.size
          this.listQuery.pageNo = res.data.data.list.current
          this.total = res.data.data.list.total
        })
    },
  }
};
</script>

<style scoped>
.demo-form-inline {
  height: 35px;
  display: flex;
}

.cor {
  border-radius: 5px;
  margin-top: 10px;
  background-color: #f4f4f5;
}

.num {
  padding: 10px;
  color: #ccc;
  font-size: 13px;
}

.el-icon-info {
  margin-right: 5px;
}

.cg {
  flex: 1;
}

.page {
  margin-top: 20px;
  text-align: right;
}

.demo-form-inline {
  height: 35px;
  display: flex;
  margin-bottom: 15px;
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/ViewRecruitment.vue